import React, { useState, useEffect } from 'react';
import WaitlistForm from './components/WaitlistForm';
import Navbar from './components/Navbar';
import './RegistrationPage.css';

const RegistrationPage = () => {
  const goHome = () => { window.location.href = '/'; };

  // Keep theme state so the registration page respects the saved theme
  const [theme, setTheme] = useState(() => {
    try {
      const saved = localStorage.getItem('theme');
      if (saved) return saved;
      return (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) ? 'dark' : 'light';
    } catch (e) {
      return 'light';
    }
  });

  useEffect(() => {
    try {
      document.documentElement.setAttribute('data-theme', theme);
      localStorage.setItem('theme', theme);
    } catch (e) {
      // ignore
    }
  }, [theme]);

  const toggleTheme = () => setTheme(prev => prev === 'dark' ? 'light' : 'dark');

  return (
    <div className="registration-page">
      <Navbar onHomeClick={goHome} onJoinClick={goHome} theme={theme} onThemeToggle={toggleTheme} />
      <div className="registration-container registration-layout">
        <div className="left-graphic" aria-hidden>
          <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Expert Supply Chain Logistics" />
        </div>
        <div className="right-content">
          <h1 className="registration-title">Contact Us / Request a Quote</h1>
          <WaitlistForm onSuccess={() => { /* success UI is handled inside WaitlistForm */ }} />
          <div className="back-home-wrap" style={{ textAlign: 'center' }}>
            <button className="link-btn back-home" onClick={goHome}>Back to home</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrationPage;
